import { Email } from "../../utils/user/form";

const RegisterEmail = (props) => <Email {...props} label="Email" />;

export default RegisterEmail;
